import axios from 'axios';
import axiosInstance from 'utils/axiosInstance';
import { hasFeature } from 'utils/featureFlags';
import * as api from './constants';

// TODO:
// Make interceptor request for any request with `withCredentials: true` config

export function login(email, password, phone) {
  const payload = phone
    ? { session: { password, phone_number: phone } }
    : { session: { email, password } };

  const endpoint = hasFeature('enable-jwt-login-flow')
    ? '/mkService/account/v2/login'
    : '/mkService/account/v1/login';

  return axiosInstance.post(endpoint, payload, {
    withCredentials: true,
  });
}

export function referral(ref) {
  return axios.get(api.REFERRAL_URL, { params: { ref } }).catch(error => {
    if (error.response) {
      const obj = new Error(error.response.data.error);
      obj.status = error.response.status;
      return Promise.reject(obj);
    }
    return Promise.reject(new Error(error.message));
  });
}

export function resendVerificationEmail(data) {
  return axios.post(api.RESEND_VERIFICATION_EMAIL_URL, data).catch(error => {
    if (error.response) {
      // The request was made, but the server responded with a status code
      // that falls out of the range of 2xx
      const eobj = new Error(error.response.data.message);
      eobj.status = error.response.data.status;
      return Promise.reject(eobj);
    }
    // Something happened in setting up the request that triggered an Error
    return Promise.reject(new Error(error.message));
  });
}

export function registered(email) {
  return axios.get(
    api.REGISTER_URL + email,
    { email },
    { withCredentials: true }
  );
}

export function validatePhone(phoneNumber) {
  return axios.post(
    api.VALIDATE_PHONE,
    { phone_number: phoneNumber },
    { withCredentials: true }
  );
}

export function generateOtp(phoneNumber) {
  return axios
    .post(
      api.GENERATE_OTP,
      { phone_number: phoneNumber },
      { withCredentials: false }
    )
    .catch(error => {
      return Promise.reject(new Error(error.response.data.reason));
    });
}

export function validateUser(email, phoneNumber) {
  return axios.all([registered(email), validatePhone(phoneNumber)]).then(
    axios.spread(function(verifiedEmail, verifiedPhone) {
      return Promise.resolve({
        verifiedEmail: verifiedEmail.data,
        verifiedPhone: verifiedPhone.data,
      });
    })
  );
}

export function registerBusiness(data) {
  return axios.post(api.REGISTER_BUSINESS_URL, data).catch(error => {
    return Promise.reject(error.response.data);
  });
}

export function getBusinessTypes() {
  const url = hasFeature('business-type-new-api')
    ? api.BUSINESS_TYPES_URL_FROM_SERVICE
    : api.BUSINESS_TYPES_URL;
  return axios.get(url);
}

export function getBusinessCategoriesAll() {
  const url = hasFeature('business-type-new-api')
    ? api.BUSINESS_CATEGORIES_ALL_URL_FROM_SERVICE
    : api.BUSINESS_CATEGORIES_ALL_URL;
  return axios.get(url);
}

export function getResetPassword(query) {
  return axios
    .get(api.GET_RESET_PASSWORD_URL, {
      params: query,
      withCredentials: true,
    })
    .catch(error => {
      const { response } = error;
      return Promise.reject(response);
    });
}
export function resetPassword(query) {
  return axios
    .post(
      api.RESET_PASSWORD_URL,
      {
        access_token: query.access_token,
        password: query.newPassword,
        password_confirmation: query.confPassword,
      },
      { withCredentials: true }
    )
    .catch(error => {
      const { response } = error;
      return Promise.reject(response);
    });
}

export function loadPrepareEncryption() {
  return axios
    .get(api.LOAD_PREPARE_ENCRYPTION_URL, { withCredentials: true })
    .catch(error => {
      const { response } = error;
      return Promise.reject(response);
    });
}
